// Bootstrap: define the ff() API, drain the stub queue, mount the widget on init.
// Install pattern mirrors analytics SDKs:
//   window.ff = window.ff || function(){(ff.q=ff.q||[]).push(arguments)};
//   ff('init', { projectId, endpoint, org, user, ingestKey, getToken });

import { normalizeConfig, readDataAttrs } from './config.js';
import { createShadow } from './ui/shadow.js';
import { injectStyles } from './ui/styles.js';
import { createLauncher } from './ui/launcher.js';
import { createPanel } from './ui/panel.js';
import { Controller } from './controller.js';

(function boot() {
  const prev = window.ff;
  const queue = (prev && prev.q) || [];
  let controller = null;

  function init(rawCfg) {
    if (controller) return; // single instance per page
    const cfg = normalizeConfig({ ...readDataAttrs(), ...(rawCfg || {}) });
    const shadow = createShadow();
    injectStyles(shadow, cfg);
    const panel = createPanel(shadow, cfg);
    const launcher = createLauncher(shadow, cfg);
    controller = new Controller(cfg, { panel, launcher });
    launcher.onClick(() => controller.open());
    if (cfg.debug) {
      // The shadow root is closed (invisible to the page and to session recorders), so tests
      // and debugging need this explicit handle. Only ever set when the integrator opts in.
      window.__ffDebug = { shadow, controller };
    }
    if (cfg.dryRun) {
      console.info('[ff] DRY RUN mode (no endpoint configured) — payloads are logged to the console on send.');
    }
  }

  function api(method, ...args) {
    if (method === 'init') return init(args[0]);
    if (method === 'open') return controller && controller.open();
    console.warn('[ff] unknown method:', method);
  }

  window.ff = api;
  queue.forEach((args) => api.apply(null, Array.prototype.slice.call(args)));
})();
